module.exports = __webpack_public_path__ + "img/Yotta/Yotta-favicon-32x32.png";